iScreenWizard.controller('GroepsprofielTestafnameSelectorController', function ($scope, $state, $filter, $interval, $mdDialog, Ajax, ErrorHandler, Dictionary, userService, Testafname, Groepscode, Testafnamestatus, nieuwGroepsprofielService) {

    var pagesize = 20;

    $scope.userService = userService;
    $scope.nieuwGroepsprofielService = nieuwGroepsprofielService;

    $scope.testafnamestatussen = [];

    $scope.loading = false;
    $scope.searchTerm = '';
    $scope.searchGroepscodeId = '0';
    $scope.aanmaakdatum_totenmet = new Date();
    $scope.aanmaakdatum_van = new Date(
        $scope.aanmaakdatum_totenmet.getFullYear()-1,
        $scope.aanmaakdatum_totenmet.getMonth(),
        $scope.aanmaakdatum_totenmet.getDate()
    );
    $scope.groepscodes = [];
    $scope.groepscodesForSelect = [];
    $scope.testafnames = [];
    $scope.testafnameFilters = {};
    $scope.testafnamePage = 1;
    $scope.testafnameMorePages = true;

    $scope.$on('$stateChangeSuccess', function (event, toState) {
        $scope.refresh();
    });

    $scope.refresh = function() {
        nieuwGroepsprofielService.model.testafnames = [];

        $scope.loadTestafnames();

        Testafnamestatus.all().then(function(testafnamestatussen) {
            angular.forEach(testafnamestatussen, function(testafnamestatus) {
                $scope.testafnamestatussen[testafnamestatus.id] = testafnamestatus;
            });
        });
        Groepscode.all().then(function(groepscodes) {
            angular.forEach(groepscodes, function(groepscode) {
                $scope.groepscodes[groepscode.id] = groepscode;
            });
            $scope.groepscodesForSelect = groepscodes;
        });
    };

    $scope.loadMoreTestafnames = function() {
        $scope.testafnamePage = $scope.testafnamePage+1;
        $scope.loadTestafnames();
    };

    $scope.loadTestafnames = function() {
        if (!$scope.loading) {
            $scope.loading = true;
            params = {
                groepsprofieloptie: nieuwGroepsprofielService.model.groepsprofieloptie.key,
                pagesize: pagesize,
                page: $scope.testafnamePage,
                orderby: 'id',
                orderdesc: true,
                geen_feedbackgevers: 1
            };
            if (nieuwGroepsprofielService.model.groepsprofieloptie.key == 3) {
                params.groepsprofiel_competenties_intellectuele_capaciteiten = nieuwGroepsprofielService.model.intellectuele_capaciteiten ? 1 : 0;
                params.groepsprofiel_competenties_competentieprofiel_id = nieuwGroepsprofielService.model.competentieprofiel.id;
            }
            if ($scope.searchTerm.length > 0) {
                params.searchterm = $scope.searchTerm;
            }
            if ($scope.aanmaakdatum_van) {
                params.aanmaakdatum_van = $filter('date')(new Date($scope.aanmaakdatum_van), 'dd-MM-yyyy');
            }
            if ($scope.aanmaakdatum_totenmet) {
                params.aanmaakdatum_totenmet = $filter('date')(new Date($scope.aanmaakdatum_totenmet), 'dd-MM-yyyy');
            }
            if ($scope.searchGroepscodeId && $scope.searchGroepscodeId > 0) {
                params.kandidaat_groepscode_id = $scope.searchGroepscodeId;
            }
            Testafname.all(params).then(function (testafnames) {
                angular.forEach(testafnames, function (testafname) {

                    testafname.index = -1;
                    angular.forEach(nieuwGroepsprofielService.model.testafnames, function (andereTestafname, index) {
                        if (andereTestafname.id == testafname.id) {
                            testafname.index = index;
                        }
                    });

                    $scope.testafnames.push(testafname);
                });
                if (testafnames.length < pagesize) {
                    $scope.testafnameMorePages = false;
                }
                $scope.loading = false;
            });
        }
    };

    $scope.searchTestafname = function() {
        if ($scope.loading) {
            $interval($scope.searchTestafname(), 100, 1);
        } else {
            $scope.testafnames = [];
            $scope.testafnameMorePages = true;
            $scope.testafnamePage = 1;
            $scope.loadTestafnames();
        }
    };

    $scope.getTestafnameIndex = function(testafname) {
        angular.forEach(nieuwGroepsprofielService.model.testafnames, function(andereTestafname, index) {
            if (andereTestafname.id == testafname.id) {
                return index;
            }
        });
        return -1;
    };

    $scope.addTestafname = function(testafname) {
        var index = $scope.getTestafnameIndex(testafname);
        if (index < 0) {
            nieuwGroepsprofielService.model.testafnames.push(testafname)
            testafname.index = nieuwGroepsprofielService.model.testafnames.length - 1;
        }
    };

    $scope.deleteTestafname = function(testafname) {
        var index = $scope.getTestafnameIndex(testafname);
        nieuwGroepsprofielService.model.testafnames.splice(index, 1);
        testafname.index = $scope.getTestafnameIndex(testafname);
    };

    $scope.downloadRapport = function(ev) {
        nieuwGroepsprofielService.SaveState();
        if (nieuwGroepsprofielService.model.testafnames.length > 1) {
            $mdDialog.show({
                controller: DownloadRapportDialogController,
                locals: {
                },
                templateUrl: '/groepsprofiel/download-rapport',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true
            });
        }
    };

    function DownloadRapportDialogController($scope, $mdDialog, nieuwGroepsprofielService) {
        $scope.stillLoading = true;
        $scope.downLoadUrl = '';

        var params = {
            _method: 'genereer_rapport',
            groepsprofieloptie: nieuwGroepsprofielService.model.groepsprofieloptie.key,
            groepsnaam: nieuwGroepsprofielService.model.naam,
            testafname_ids: []
        };

        if (nieuwGroepsprofielService.model.groepsprofieloptie.key == 3) {
            params.intellectuele_capaciteiten = nieuwGroepsprofielService.model.intellectuele_capaciteiten;
            params.competentieprofiel_id = nieuwGroepsprofielService.model.competentieprofiel.id;
        }

        angular.forEach(nieuwGroepsprofielService.model.testafnames, function(testafname) {
            params.testafname_ids.push(testafname.id);
        });

        Ajax.post('groepsprofiel', params).then(function (response) {
            $scope.stillLoading = false;
            if (ErrorHandler.hasErrors(response)) {
                ErrorHandler.showDialog(response);
            } else {
                $scope.downLoadUrl = baseUrl + response.data.file_url + '?jwt=' + userService.getToken();
            }
        });
    }

});